import { Col, Descriptions, Row } from 'antd';
// import Sorefsis from 'components/sorefsis';
import { isEmpty } from 'lodash';
// import SorefsisChart from 'pages/mainForms/mainForm/components/basicInfo/components/sorefsisChart';
import React, { useEffect, useState } from 'react';
import { getDetails } from 'store/appTrack/actions';
import { printInfo, printInfoBoolean, getFullDateTimeWithSeconds } from 'store/appTrack/utils';
import {ReactComponent as GroupIcons} from '../../../../../assets/icons/group_icons.svg';
import { useSelector, useDispatch } from 'react-redux';

const BasicInfo = () => { 

  const apptrackDetails = useSelector(state=>state.appTrack.apptrackDetails);

  const response = Object.keys(apptrackDetails?.variablesIndexed).length === 1 && apptrackDetails?.variablesIndexed.hasOwnProperty('initiator') ? apptrackDetails?.localTaskVariables : apptrackDetails?.variablesIndexed;


  const vulnerableHouseholdAud = response?.vulnerableHouseholdAud;
  
  const getSubsidyPercentage = () => {
    if (response?.equipmentType !== 'equipmentTypeThermosifonas') {
    return '50%';
  }
    if (typeof vulnerableHouseholdAud === 'undefined' || vulnerableHouseholdAud === null) {
      return '-';
    }
    return vulnerableHouseholdAud ? '60%' : '50%';
  };

  return (
    <div className=''>
      <div style={{display:"flex"}}>
        <Descriptions
          title="Στοιχεία Ωφελούμενου"
          bordered
          className="large-titles-purple-responsive investment-plan-details-table"
          style={{width:"47%", marginRight:"6%"}}
          column={1}
        >
          <Descriptions.Item label="Ονοματεπώνυμο">
            {printInfo(response.legalName)} {printInfo(response.legalSurname)}
          </Descriptions.Item>
          <Descriptions.Item label="Πατρώνυμο">
            {printInfo(response.legalFather)}
          </Descriptions.Item>
          <Descriptions.Item label="Ημ. Γέννησης">
            {getFullDateTimeWithSeconds(response.birthDate)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Δ.Τ. / Διαβατηρίου">
            {printInfo(response.legalAdt)}
          </Descriptions.Item>
          <Descriptions.Item label="Α.Φ.Μ.">
            {printInfo(response.legalVat)}
          </Descriptions.Item>
          <Descriptions.Item label="Οδός - Αριθμός">
            {printInfo(response.abiStreet)}
          </Descriptions.Item>
          <Descriptions.Item label="Τ.Κ.">
            {typeof(response?.abiTk) !== 'object' ? printInfo(response?.abiTk) : "-"}
          </Descriptions.Item>
          <Descriptions.Item label="Περιφερειακή Ενότητα / Δήμος">
            {printInfo(response.abiPerfecture) + '/' + printInfo(response.abiDistrict)}
          </Descriptions.Item>
          <Descriptions.Item label="Κινητό Τηλέφωνο">
            {printInfo(response.legalPhoneMobile)}
          </Descriptions.Item>
          <Descriptions.Item label="E-mail Επικοινωνίας">
            {printInfo(response.legalEmail)}
          </Descriptions.Item>
        </Descriptions>

        <div style={{width:"47%"}}>
          <Descriptions
            title="Στοιχεία Ακινήτου"
            bordered
            className="large-titles-purple-responsive investment-plan-details-table"
            column={1}
          >
            <Descriptions.Item label="Είστε Ιδιοκτήτης ή Ενοικιαστής;">
              {(response?.ownerStatus === 'ownerStatusOwner') ? 
                'Ιδιοκτήτης' 
              : (response?.ownerStatus === 'ownerStatusRenting') ? 
                'Ενοικιαστής' 
              : "Χρήστης δωρεάν παραχωρούμενης κατοικίας"
              
              }
            </Descriptions.Item>
            <Descriptions.Item label="Ονοματεπώνυμο Ιδιοκτήτη">
              {response.ownerFirstname && response.ownerSurname 
                ? `${printInfo(response?.ownerFirstname)} ${printInfo(response?.ownerSurname)}`
                : "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Α.Φ.Μ. Ιδιοκτήτη">
              {printInfo(response?.ownerVat)}
            </Descriptions.Item>
            <Descriptions.Item label="Οδός - Αριθμός">
              {printInfo(response?.buildStreetBuilding)}
            </Descriptions.Item>
            <Descriptions.Item label="Τ.Κ.">
              {printInfo(response?.buildTkBuilding)}
            </Descriptions.Item>
            <Descriptions.Item label="Περιφερειακή Ενότητα / Δήμος">
              {printInfo(response?.buildPerfectureBuilding) + '/' + printInfo(response.abiDistrictBuilding)}
            </Descriptions.Item>
            <Descriptions.Item label="Αρ. Παροχής Ρεύματος">
              {printInfo(response?.powerNumberBuilding)}
            </Descriptions.Item>
            <Descriptions.Item label="Είναι Ενεργή η Παροχή Ρεύματος;">
              {printInfoBoolean(response?.powerSupply)}
            </Descriptions.Item>
            <Descriptions.Item label="Είναι η Παροχή Ρεύματος Οικιακή;">
              {printInfoBoolean(response?.powerSupplyPrivate)}
            </Descriptions.Item>
            <Descriptions.Item label="Είναι η Παροχή Ρεύματος Κοινόχρηστη;">
              {printInfoBoolean(response?.powerSupplyPublic)}
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
      {/* contactPersonFlag true means legal representative is also contact person*/}
      <div style={{display:"flex", marginTop:"5%"}}>
        <Descriptions
          title="Στοιχεία Κριτηρίων"
          bordered
          className="large-titles-purple descriptions-table-graye"
          column={1}
          style={{width:"47%", marginRight:"6%"}}
        >
          {response.equipmentType === "equipmentTypeThermosifonas" && (
            <>
              <Descriptions.Item label="Ατομικό Εισόδημα 2023">
                {printInfo(response.individualIncome)}
              </Descriptions.Item>
              <Descriptions.Item label="Οικογενειακό Εισόδημα 2023">
                {printInfo(response.legalIncome)}
              </Descriptions.Item>
            </>
          )}
          <Descriptions.Item label="Αρ. Εξαρτώμενων Τέκνων">
            {printInfo(response.legalChildren)}
          </Descriptions.Item>
          <Descriptions.Item label="Υπάρχει Μέλος ΑΜΕΑ στην Οικογένεια">
            {printInfoBoolean(response.ameaMember)}
          </Descriptions.Item> 
        </Descriptions>
        <Descriptions
          title="Αξιολόγηση"
          bordered
          className="large-titles-purple descriptions-table-graye"
          style={{width:"47%"}}
          column={1}
        >
          <Descriptions.Item label="Ποσοστό Επιδότησης">
            {getSubsidyPercentage()}
          </Descriptions.Item>
        </Descriptions>
      </div>
      <Row
    gutter={{ xs: 0, sm: 2, md: 5, lg: 10 }}
    className="carrier-data-form__row mt-6 sorefsis"
  >
    {/* <Col span={16} className="sorefsis-col-1">
      <>
        <Sorefsis></Sorefsis>
      </>
    
    </Col>
    <Col span={8} className="sorefsis-col-2">
      <div className="carrier-data-form mt-3">
        <SorefsisChart realValue={response.totalAmountSorefsis ? response.totalAmountSorefsis : 0} limit={process.env.REACT_APP_SOREFSIS_AMOUNT}/>
      </div>
    </Col> */}
  </Row>
    </div>
    
  );
};

export default BasicInfo;